import Vue from 'vue'
// element 在 utils/element.js 中按需引入
import './utils/permissions'
import './utils/element'
import Vant from 'vant'
import 'vant/lib/index.css'
import router from './router'
import store from './store'
import App from './App.vue'
import selfTitle from './components/Title.vue'

// 其他组件，不是公共组件，就在相关页面 import 使用
import { baseURL, get, post, formData, formUrlencoded, get3, post3 } from './utils/service'
import * as common from './utils/common'
import { fgId18Validate } from './utils/fgId18Validate'

Vue.component('selfTitle', selfTitle) // 通用标题
Vue.use(Vant)

Vue.prototype.$baseURL = baseURL
Vue.prototype.$get = get
Vue.prototype.$post = post
Vue.prototype.$get3 = get3
Vue.prototype.$post3 = post3
Vue.prototype.$formUrlencoded = formUrlencoded
Vue.prototype.$formData = formData
Vue.prototype.$common = common
Vue.prototype.$fgId18Validate = fgId18Validate

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
